import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { StreamState } from '@app/core/interfaces/stream-state';
import { AudioPlayingService } from '@app/core/services/audio-playing.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
@Component({
  selector: 'audio-player',
  templateUrl: './audio-play.component.html',
  styleUrls: ['./audio-play.component.css']
})
export class AudioPlayComponent implements OnInit, OnDestroy {
  @Input() audioLink: any;
  @Input() isAutoPlay: boolean = true;
  @Input() audioState: 'start' | 'play' | 'ended' | 'restart' | 'cancel' | undefined;

  @Output() audioEnd: any = new EventEmitter<any>();

  public isCountDown: boolean = false;

  state: StreamState;
  public sub: Subscription;
  public isPlayClick: boolean = false;
  public isDisablePlay: boolean = false;
  math = Math;
  
  constructor(public audioService: AudioPlayingService,private sanitizer: DomSanitizer) {
    this.audioService.getState().subscribe(state => {
      this.state = state;
      if (this.state.playing) this.isPlayClick = false;
    });
  }


  playStream() {
    this.isPlayClick = true;
    this.isDisablePlay = true;
    this.sub = this.audioService.playStream(this.audioLink).subscribe((data: any) => {
      if (data.type == 'ended') {
        this.audioState = data.type;
        this.audioEnd.emit(data.type);
      }

    });

  }

  ngOnInit() {
    this.isCountDown = true;
    if(this.isAutoPlay==false)
    this.audioLink = this.sanitizer.bypassSecurityTrustUrl(this.audioLink);
  }

  isMobile() {
    try { document.createEvent("TouchEvent"); return true; }
    catch (e) { return false; }
  }

  isInfoMessage: boolean = false;
  onTimmerEnd() {
    this.isCountDown = false;
    if (!this.isMobile()) {
      if (this.isAutoPlay)
        this.playStream();
    }

    else {
      this.isInfoMessage = true;

    }
  }

  ngOnChanges(): void {

    // if (this.audioState == "start" || this.audioState == undefined) {
    //   clearInterval(this.interval1);
    //   // this.coundDuration=12;
    //   this.isCountDown = true;
    //   this.anni = undefined;

    //   // this.answerLists=[];
    //   // this.answerArr.emit(this.answerLists);
    // }

  }

  ngOnDestroy(): void {
    if (this.sub)
      this.sub.unsubscribe();
  }
}
